import React from 'react';
import { Link } from 'react-router-dom';
interface QuotaMeterProps {
  used: number;
  limit: number;
  planName: string;
  /** 'shell' sits on the dark sidebar, 'panel' on light surfaces. */
  tone?: 'shell' | 'panel';
  pendingDelta?: number;
  showUpgrade?: boolean;
}
export function QuotaMeter({
  used,
  limit,
  planName,
  tone = 'panel',
  pendingDelta = 0,
  showUpgrade = true
}: QuotaMeterProps) {
  const projected = used + pendingDelta;
  const ratio = Math.min(1, projected / limit);
  const full = projected >= limit;
  const onShell = tone === 'shell';
  const barColor = onShell ? full ? 'bg-warn-bright' : 'bg-brand-bright' : full ? 'bg-warn' : 'bg-brand';
  return <div className={onShell ? 'rounded-card border border-shell-line bg-shell-raised p-3' : 'rounded-card border border-line bg-canvas p-4'} data-id="element-417" data-mp="21txhgcagpx3k">
      <div className="flex items-baseline justify-between gap-2" data-id="element-418" data-mp="2auvqj8zrcut0">
        <span className={`text-[11px] font-semibold uppercase tracking-wide ${onShell ? 'text-white/50' : 'text-ink-soft'}`} data-id="element-419" data-mp="5ewhng4qqe8r">
          Services
        </span>
        <span className={`tabular text-[13px] font-semibold ${onShell ? 'text-white' : 'text-ink'}`} data-id="element-420" data-mp="3sjkt3wc7i0vx">
          {projected} / {limit}
        </span>
      </div>

      <div className={`mt-2.5 h-1.5 w-full overflow-hidden rounded-full ${onShell ? 'bg-white/10' : 'bg-line'}`} role="progressbar" aria-valuenow={projected} aria-valuemin={0} aria-valuemax={limit} aria-label={`${projected} of ${limit} services used`} data-id="element-421" data-mp="p2m375m33i9j">
        <div className={`h-full rounded-full transition-[width] duration-200 ease-snap ${barColor}`} style={{
        width: `${ratio * 100}%`
      }} data-id="element-422" data-mp="acy14262wfkr" />
      </div>

      <p className={`mt-2 text-xs leading-relaxed ${onShell ? 'text-white/60' : 'text-ink-muted'}`} data-id="element-423" data-mp="1324yuyxpl14y">
        {full ? `${planName} is full. Free up a service or move up a plan.` : `${limit - projected} left on ${planName}. One check on one domain = one service.`}
      </p>

      {showUpgrade && <Link to="/app/billing" className={`mt-2 inline-block text-xs font-medium underline decoration-1 underline-offset-2 transition-colors duration-150 ease-snap ${onShell ? 'text-brand-bright hover:text-white' : 'text-brand hover:text-brand-hover'}`} data-id="element-424" data-mp="2nkfjkvyuqz8r">
          Manage plan
        </Link>}
    </div>;
}